module.exports = __webpack_public_path__ + "img/dont.8734c7f5.png";